import React from "react"
import Error from "next/error"
import SpaceDetailsPage from "../../features/pages/SpaceDetailsPage"
import galleryApiService from "../../services/galleryApiService"

const SpaceDetails = ({ spaceDetails, errorCode }) => {
  if (errorCode) {
    return <Error statusCode={404} />
  }
  return <SpaceDetailsPage spaceDetails={spaceDetails} />
}

export const getServerSideProps = async ({ params }) => {
  try {
    const response = await galleryApiService.space(params.id)

    return {
      props: {
        errorCode: !response.data,
        spaceDetails: response.data,
      },
    }
  } catch (e) {
    return {
      props: {
        errorCode: true,
      },
    }
  }
}

export default SpaceDetails
